module.exports = __webpack_public_path__ + "img/3939784_0080.71c3db08.jpg";